export default __webpack_public_path__ + "static/demande.maro-82387ca4321f0229ca5936a44ad45f14.jpg";